
export const en = {
  menu: {
    dashboard: 'Dashboard',
    projects: 'Projects',
    teams: 'Teams',
    schedule: 'Schedule',
    documents: 'Documents',
    reports: 'Reports',
    settings: 'Settings',
    info: 'Info',
    budget: 'Budget RAB',
    admin: 'Administrator',
    adminChat: 'Chat Management',
    adminMembers: 'Member Management'
  },
  settings: {
    title: 'Settings',
    general: 'General',
    notifications: {
      title: 'Notifications',
      description: 'Manage how you receive notifications',
      email: 'Email notifications',
      push: 'Push notifications',
      projectUpdates: 'Project updates',
      taskReminders: 'Task reminders'
    },
    data: {
      title: 'Data & Storage',
      description: 'Manage your data and storage preferences',
      sync: {
        title: 'Auto Sync',
        description: 'Automatically sync data across devices'
      },
      cache: {
        title: 'Clear Cache',
        description: 'Clear locally stored data'
      },
      localProjects: {
        title: 'Local Projects',
        description: 'Projects stored on this device'
      },
      export: {
        title: 'Export Data',
        description: 'Download your project data'
      }
    },
    appearance: {
      title: 'Appearance',
      description: 'Customize the look and feel',
      darkMode: 'Dark mode',
      minimalistTheme: 'Minimalist theme',
      sidebarType: 'Sidebar style',
      sidebarDescription: 'Choose your preferred navigation style',
      circular: 'Circular',
      compact: 'Compact'
    },
    language: {
      title: 'Language',
      description: 'Choose your preferred language',
      select: 'Select Language',
      english: 'English',
      indonesian: 'Indonesian',
      changeInfo: 'Language changes will be applied immediately'
    }
  },
  info: {
    title: 'Project Information',
    about: 'About This Project',
    version: 'Version',
    lastUpdated: 'Last Updated',
    documentation: 'Documentation',
    support: 'Support',
    feedback: 'Send Feedback',
    developer: 'Developer'
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    remove: 'Remove',
    confirm: 'Confirm',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information'
  }
};
